import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('path-finder')
  .factory()

export {
  Provider as PathFinderReportProvider,
  useStore as usePathFinderReportStore,
}
